import script from "./PaymentBase.vue?vue&type=script&lang=ts"
export * from "./PaymentBase.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__